module.exports = __webpack_public_path__ + "images/emoji/waning_gibbous_moon.767de63527d0635972da.png";